import { onBeforeMount } from '#build/imports'
import { IPagination } from '~/types/pagination.type'


export const usePagination = (pageParam: IPagination, updateRouter = true) => {
  const defaultPageParam = { ...pageParam }
  const pagination = ref(pageParam)
  const rowPerPageList = [ 25, 50, 100 ]

  const route = useRoute()
  const setPage = (page: number) => {
    if (!page) return
    pagination.value.page = page
  }
  const setRowPerPage = (rowPerPage: number) => {
    if (!rowPerPageList.includes(rowPerPage)) return
    pagination.value.rowPerPage = rowPerPage
  }

  const updatePagination = () => {
    const page = Number.parseInt(route.query.page as string)
    setPage(page || defaultPageParam.page)

    const rowPerPage = Number.parseInt(route.query.rowPerPage as string)
    setRowPerPage(rowPerPage || defaultPageParam.rowPerPage)
  }

  onBeforeMount(updatePagination)

  watchEffect(() => {
    updatePagination()
  })

  const router = useRouter()
  watch(pagination, () => {
    if (updateRouter) {
      router.push({
        query: {
          page: pagination.value.page,
          rowPerPage: pagination.value.rowPerPage
        },
        replace: pagination.value.page === defaultPageParam.page
      })
    }
  }, { deep: true })

  return {
    pagination,
    rowPerPageList
  }
}